import { createRoot } from 'react-dom/client'
import SearchInit from './components/SearchInit'

const container = document.getElementById('ss-react-init')!
const root = createRoot(container)
root.render(
    <SearchInit />
)
